import React from "react";
import { useLocalStorage } from "@uidotdev/usehooks";
import { useSearchParams } from "react-router-dom";
import { useTraceabilityData } from "./contexts/TraceabilityDataContext";
import ProductItem from "./components/ProductItem";
import CowCard from "./cowcard";

const getCowImage = (breed, apiImage) => {
  if (apiImage && apiImage !== "null") return apiImage;

  if (breed) {
    const formattedBreed = breed.trim();
    return `/img/breeds/${formattedBreed}.jpg`;
  }

  return "/img/breeds/Dummy.png";
};


const MeetOurCowsTwo = () => {
  const [storedName] = useLocalStorage("name", null);
  const [searchParams] = useSearchParams();
  const farmerId = searchParams.get("farmerId");
  const { farmersData, cowsData, loading, errors } = useTraceabilityData();

  const cowsFromApi = cowsData?.mappedCows || [];

  // Find the specific farmer if farmerId is provided
  const selectedFarmer =
    farmerId && farmersData?.mappedFarmers
      ? farmersData.mappedFarmers.find(
        (f) => f.id === farmerId || String(f.id) === farmerId,
      )
      : null;

  // Get cows for the selected farmer, or all cows if no farmer selected
  // const selectedFarmer =
  //   farmerId && farmersData?.mappedFarmers
  //     ? farmersData.mappedFarmers.find(
  //         (f) => String(f.id) === String(farmerId)
  //       )
  //     : null;

  const cows = cowsFromApi
    .filter((cow) => {
      if (!selectedFarmer) return true;

      return (
        cow.farmerObj?.farmerName &&
        selectedFarmer.name &&
        cow.farmerObj.farmerName.trim().toLowerCase() ===
        selectedFarmer.name.trim().toLowerCase()
      );
    })
    .map((cow) => ({
      id: cow.id,
      name: cow.name || "Cow",
      regNo: cow.regNo || "-",
      breed: cow.breed || "-",
      dob: cow.dob || "-",
      img: getCowImage(cow.breed, cow.img),

      healthObj: cow.healthObj,
      farmerObj: cow.farmerObj,
      about: cow.about || "",
    }));

  const pageTitle = "Meet Our Cattle";

  const pageDescription =
    "Learn more about the cows that provide your milk. Explore their health, lineage, and the farmers who care for them.";

  return (
    <div className="bg-light">
      {/* Page Heading */}
      <div className="wrapper2">
        <h2 className="heading2">Meet Our Cattle</h2>
      </div>

      <section className="py-0">
        <div className="container py-0">
          <div className="row g-3">
            <div className="col-lg-4 col-12">
              <p className="card-text text-muted py-3 px-2">
                {pageDescription ||
                  "Each cattle is like family to us, with her own unique ID that tracks her every step. We make sure her health, vaccinations, and calving are all carefully followed. Our vets treat her like their own, ensuring she’s happy and healthy. Every part of her journey contributes to the milk you enjoy. To us, she’s not just a cattle—she’s the heart of everything we do."}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Farmer Info (if specific farmer selected) */}
      {/* {selectedFarmer && (
        <section className="py-0">
          <div className="container py-0">
            <div className="row g-3">
              <div className="col-lg-4 col-12">
                <div className="cw-container" style={{ display: "flex", background: "white", borderRadius: "10px", overflow: "hidden", marginBottom: "20px" }}>
                  <div className="cw-image-section" style={{ position: "relative", height: "150px", width: "150px", flexShrink: 0 }}>
                    <img
                      src={selectedFarmer.image || "img/f1.png"}
                      alt={selectedFarmer.name}
                      style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "10px 0 0 10px" }}
                    />
                  </div>
                  <div className="cw-content" style={{ padding: "12px", flex: 1 }}>
                    <div className="cw-details">
                      <h2 style={{ fontSize: "18px", marginBottom: "5px" }}>{selectedFarmer.name}</h2>
                      <p style={{ fontSize: "12px", color: "#313030", marginBottom: "5px" }}>
                        Registration No: {selectedFarmer.registrationNo || "-"}
                      </p>
                      <p style={{ fontSize: "12px", color: "#313030", marginBottom: "5px" }}>
                        DOB: {selectedFarmer.dob || "-"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      )} */}

      {/* Intro */}
      {/* <section className="py-0">
        <div className="container py-0">
          <div className="row g-3">
            <div className="col-lg-4 col-12">
              <p className="card-text text-muted py-3 px-2">
                {loading.farmers && "Loading cattle information..."}
                {!loading.farmers && errors.farmers && "Error loading cattle data."}
                {!loading.farmers && !errors.farmers && pageDescription}
              </p>
            </div>
          </div>
        </div>
      </section> */}

      {/* Cow Profiles */}
      {cows.length > 0 ? (
        <div
          className="cw-slider-container"
          style={{
            paddingTop: "29px",
            display: "flex",
            flexWrap: "wrap",
            gap: 20,
          }}
        >
          {cows.map((cow) => (
            <div
              key={cow.id}
              style={{
                flex: "0 0 100%",
                maxWidth: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "260px",
              }}
            >
              <CowCard cow={cow} />
            </div>
          ))}
        </div>
      ) : (
        !loading.farmers && (
          <div className="container py-4">
            <p className="text-center text-muted">
              {farmerId
                ? "No cattle found for this farmer."
                : "No cattle information available."}
            </p>
          </div>
        )
      )}

      {/* Traceability Journey */}
      <div className="wrapper2 mt-5">
        <h2 className="heading2">Your Traceability Journey</h2>
      </div>
      <div className="bg-light">
        <div className="container p-3">
          <div className="row row-cols-xl-5 row-cols-lg-5 row-cols-md-2 row-cols-2 g-3">
            <ProductItem
              href="/dairy-farm"
              imageSrc="img/box1.png"
              stepNumber="01"
              title="Dairy Farms"
              description="Every batch begins with fresh milk collected from our trusted p2ers."
            />
            <ProductItem
              href="/milk-grading"
              imageSrc="img/box2.png"
              stepNumber="02"
              title="Milk Grading"
              description="Ensuring fair pricing and top-quality milk through meticulous grading."
            />
            <ProductItem
              href="/quality-check"
              imageSrc="img/box3.png"
              stepNumber="03"
              title="Quality Check"
              description="Rigorous testing of the milk to guarantee purity and freshness."
            />
            <ProductItem
              href="/manufacturing"
              imageSrc="img/box4.png"
              stepNumber="04"
              title="Manufacturing"
              description="Advanced technology transforms raw milk into the highest quality product."
            />
            <ProductItem
              href="/distribution"
              imageSrc="img/box5.png"
              stepNumber="05"
              title="Distribution"
              description="Delivering fresh products to you swiftly and efficiently."
            />
            <ProductItem
              href="/it-is-you"
              imageSrc="img/box6.png"
              stepNumber="06"
              title={` It's ${storedName || "You"}! `}
              description="Fresh, quality products crafted with care and delivered with trust—just for you."
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MeetOurCowsTwo;
